import Modal from 'LuxKit/Modal/Modal'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useIntl } from 'react-intl'

function ConfirmDismissSuggestions() {
  const intl = useIntl()
  const modalElement = useModalElementContext<boolean>()

  const modalTitle = intl.formatMessage({
    id: 'G1HSNe7jbD0oN_4G2e_U',
    defaultMessage: 'Delete recommendations',
    description: 'Title for the modal confirming deletion of trip recommendations',
  })
  const confirmText = intl.formatMessage({
    id: 'ICkd2XDVI5AEDxD6zDMt',
    defaultMessage: 'Confirm',
    description: 'Button text to confirm dismissing trip recommendations',
  })
  const cancelText = intl.formatMessage({
    id: 'G9XmkKQJRFRsRKGsApCE',
    defaultMessage: 'Cancel',
    description: 'Button text to cancel dismissing trip recommendations',
  })
  const bodyText = intl.formatMessage({
    id: 'IQCbh9dZFN_B7O742h2q',
    defaultMessage: 'Are you sure you want to dismiss these recommendations from your trip? This action can’t be undone.',
    description: 'Confirmation message warning that dismissing trip recommendations is irreversible',
  })

  return (
    <Modal
      title={modalTitle}
      primaryActionText={confirmText}
      onPrimaryActionClick={() => modalElement.resolve(true)}
      secondaryActionText={cancelText}
      onSecondaryActionClick={() => modalElement.resolve(false)}
    >
      {bodyText}
    </Modal>
  )
}

export default ConfirmDismissSuggestions
